import React from 'react'
import styled from 'styled-components'
import type { PopulatedResidentNeed } from '../../../../shared/hooks/useCarePlanPopulated'
import NeedItem from './NeedItem'

interface NeedsListProps {
  items: PopulatedResidentNeed[]
  disabled?: boolean
  lastReviewDate?: string
  onRemove?: (needId: string) => void
  /** Ids of resident needs that originated from an accepted AI suggestion. */
  aiNeedIds?: Set<string>
  testId?: string
  /** Extra rows rendered after the linked needs (staged suggestion drafts). */
  children?: React.ReactNode
}

const NeedsList: React.FC<NeedsListProps> = ({
  items,
  disabled = false,
  lastReviewDate,
  onRemove,
  aiNeedIds,
  testId,
  children
}) => {
  const hasChildren = React.Children.count(children) > 0
  if (!items?.length && !hasChildren) {
    return null
  }

  return (
    <Wrapper data-testid={testId}>
      <ItemsWrapper>
        {items.map((item, index) => (
          <NeedItem
            key={item.id}
            need={item}
            disabled={disabled}
            lastReviewDate={lastReviewDate}
            onRemove={onRemove}
            aiAssisted={aiNeedIds?.has(item.id) ?? false}
            testId={testId ? `${testId}-row-${index}` : undefined}
          />
        ))}
        {children}
      </ItemsWrapper>
    </Wrapper>
  )
}

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`

const ItemsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`

export default NeedsList
